// Node Modules
import React, { Component } from "react";

// Global Components
import Button from "components/button/button";
import ButtonGroup from "components/buttonGroup/buttonGroup";

// Local CSS
import "./optionSelector.css";

class OptionSelector extends Component {
  render() {
    return (
      <div className="option-selector">
        <ButtonGroup>
          {this.props.options.values.map((option, index) => {
            if (this.props.value === option.value) {
              return (
                <Button
                  color="lightGray"
                  key={index}
                  selected
                  onClick={() => {
                    this.props.selectOption(
                      this.props.optionTitle,
                      option.value
                    );
                  }}
                >
                  <p>{option.value}</p>
                </Button>
              );
            }
            return (
              <Button
                color="lightGray"
                key={index}
                onClick={() => {
                  this.props.selectOption(this.props.optionTitle, option.value);
                }}
              >
                <p>{option.value}</p>
              </Button>
            );
          })}
        </ButtonGroup>
      </div>
    );
  }
}

export default OptionSelector;
